import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create
export const createTdsSurchargeCess = createAsyncThunk(
  'tdsSurchargeCess/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/tds-surcharge-cess', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create TDS Surcharge/Cess');
    }
  }
);

// Get All
export const fetchTdsSurchargeCessList = createAsyncThunk(
  'tdsSurchargeCess/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/tds-surcharge-cess');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch list');
    }
  }
);

// Get By ID
export const fetchTdsSurchargeCessById = createAsyncThunk(
  'tdsSurchargeCess/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/tds-surcharge-cess/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch record');
    }
  }
);

// Update
export const updateTdsSurchargeCess = createAsyncThunk(
  'tdsSurchargeCess/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/tds-surcharge-cess/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update record');
    }
  }
);

// Delete
export const deleteTdsSurchargeCess = createAsyncThunk(
  'tdsSurchargeCess/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/tds-surcharge-cess/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete record');
    }
  }
);
